module.exports = __webpack_public_path__ + "img/tv.25c2d920.svg";